<div *ngIf="message" data-test-id="modal-default" class="modal-window">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title">{{ message.title | translate }}</h4>

    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"> </svg-icon>
    </button>
  </div>

  <div class="modal-body text-break" data-test-id="wrap-info-dialog">
    <p data-test-id="modal-description">
      <ng-container *ngFor="let item of message.content; index as i">
        <ng-container [ngSwitch]="item.type">
          <ng-template [ngSwitchCase]="'text'"
            ><span [innerHTML]="item.value | translate: item?.translateParams"></span>
          </ng-template>

          <ng-template [ngSwitchCase]="'signup'">
            <a [routerLink]="REGISTRATION_LINK" (click)="closeDialog()" [attr.data-test-id]="'description-link-' + i">
              {{ item.value | translate }}
            </a>
          </ng-template>

          <ng-template [ngSwitchCase]="'email'">
            <a [attr.href]="'mailto:' + item.value" [attr.data-test-id]="'description-link-' + i">{{ item.value }}</a>
          </ng-template>
        </ng-container>
      </ng-container>
    </p>
  </div>

  <div class="modal-footer" data-test-id="modal-footer">
    <ng-container *ngIf="!hasActions">
      <button class="btn btn-primary" (click)="closeDialog()" [attr.data-test-id]="'modal-btn-0'">
        {{ 'BTN_CLOSE_HINT' | translate }}
      </button>
    </ng-container>

    <ng-container *ngFor="let action of message.replies; index as i; odd as isOdd; even as isEven">
      <button
        (click)="invokeCallback(action.callback)"
        class="btn"
        [ngClass]="{ 'btn-secondary': isEven, 'btn-primary': isOdd || message.replies.length === 1 }"
        [attr.data-test-id]="'modal-btn-' + i"
      >
        {{ action.label | translate }}
      </button>
    </ng-container>
  </div>
</div>
